import {
  applePayButtonRendered as applePayButtonRenderedOriginal,
  expressCheckoutWidgetButtonClicked as expressCheckoutWidgetButtonClickedOriginal,
  applePayMerchantValidationError as applePayMerchantValidationErrorOriginal,
  applePayMerchantValidationSucceeded as applePayMerchantValidationSucceededOriginal,
  applePayStartMerchantValidation as applePayStartMerchantValidationOriginal,
  applePayPaymentAuthorized as applePayPaymentAuthorizedOriginal,
  applePayCallBackReceived as applePayCallBackReceivedOriginal,
  applePayShippingAddressNotAccepted as applePayShippingAddressNotAcceptedOriginal,
} from '@wix/bi-logger-cashier-ugc/v2';
import {
  applePayButtonRenderedParams as applePayButtonRenderedParamsOriginal,
  expressCheckoutWidgetButtonClickedParams as expressCheckoutWidgetButtonClickedParamsOriginal,
  applePayMerchantValidationErrorParams as applePayMerchantValidationErrorParamsOriginal,
  applePayMerchantValidationSucceededParams as applePayMerchantValidationSucceededParamsOriginal,
  applePayStartMerchantValidationParams as applePayStartMerchantValidationParamsOriginal,
  applePayPaymentAuthorizedParams as applePayPaymentAuthorizedParamsOriginal,
  applePayCallBackReceivedParams as applePayCallBackReceivedParamsOriginal,
  applePayShippingAddressNotAcceptedParams as applePayShippingAddressNotAcceptedParamsOriginal,
} from '@wix/bi-logger-cashier-ugc/v2/types';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';

export type applePayButtonRenderedParams = applePayButtonRenderedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethod.ApplePay;
};

export const applePayButtonRendered: (
  p: applePayButtonRenderedParams,
) => ReturnType<typeof applePayButtonRenderedOriginal> = applePayButtonRenderedOriginal;

export type expressCheckoutWidgetButtonClickedParams = expressCheckoutWidgetButtonClickedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethod.ApplePay;
};

export const expressCheckoutWidgetButtonClicked: (
  p: expressCheckoutWidgetButtonClickedParams,
) => ReturnType<typeof expressCheckoutWidgetButtonClickedOriginal> = expressCheckoutWidgetButtonClickedOriginal;

export type applePayMerchantValidationErrorParams = applePayMerchantValidationErrorParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethod.ApplePay;
};

export const applePayMerchantValidationError: (
  p: applePayMerchantValidationErrorParams,
) => ReturnType<typeof applePayMerchantValidationErrorOriginal> = applePayMerchantValidationErrorOriginal;

export type applePayMerchantValidationSucceededParams = applePayMerchantValidationSucceededParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethod.ApplePay;
};

export const applePayMerchantValidationSucceeded: (
  p: applePayMerchantValidationSucceededParams,
) => ReturnType<typeof applePayMerchantValidationSucceededOriginal> = applePayMerchantValidationSucceededOriginal;

export type applePayStartMerchantValidationParams = applePayStartMerchantValidationParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethod.ApplePay;
};

export const applePayStartMerchantValidation: (
  p: applePayStartMerchantValidationParams,
) => ReturnType<typeof applePayStartMerchantValidationOriginal> = applePayStartMerchantValidationOriginal;

export type applePayPaymentAuthorizedParams = applePayPaymentAuthorizedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethod.ApplePay;
};

export const applePayPaymentAuthorized: (
  p: applePayPaymentAuthorizedParams,
) => ReturnType<typeof applePayPaymentAuthorizedOriginal> = applePayPaymentAuthorizedOriginal;

export type applePayCallBackReceivedParams = applePayCallBackReceivedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethod.ApplePay;
};

export const applePayCallBackReceived: (
  p: applePayCallBackReceivedParams,
) => ReturnType<typeof applePayCallBackReceivedOriginal> = applePayCallBackReceivedOriginal;

export type applePayShippingAddressNotAcceptedParams = applePayShippingAddressNotAcceptedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod.ApplePay;
};

export const applePayShippingAddressNotAccepted: (
  p: applePayShippingAddressNotAcceptedParams,
) => ReturnType<typeof applePayShippingAddressNotAcceptedOriginal> = applePayShippingAddressNotAcceptedOriginal;
